module.exports = "/images/car.svg?a0f78076f439cb562fb7cb94fe333da4";